import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DAcRegistration.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem } from '../../utils';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DAcRegistrationForm from './components/DAcRegistrationForm';
import DAcConfirmation from '../DAcConfirmation/DAcConfirmation';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
var DAcRegistration = function DAcRegistration(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showBanner = _useState2[0],
    setShowBanner = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    email = _useState4[0],
    setEmail = _useState4[1];
  var _fields$data = fields.data,
    configuration = _fields$data.configuration,
    dictionary = _fields$data.dictionary,
    settings = _fields$data.settings;
  var apiKey = get(settings, 'apiKey.jss.value');
  var apiUrl = get(settings, 'apiUrl.jss.value');
  getDictionaryItem(dictionary, 'password');
  getDictionaryItem(dictionary, 'username');
  var bannerFields = {
    data: {
      configuration: {
        title: configuration.invitationSectionTitle,
        shortDescription: configuration.invitationSectionDescription,
        image: configuration.invitationImage,
        description: {
          jss: {
            value: (get(configuration, 'invitationDescription.jss.value') || '').replace('$email$', email)
          }
        },
        // inside
        contentTitle: configuration.invitationTitle,
        // inside
        buttonLabel: {
          jss: {
            value: getDictionaryItem(dictionary, 'continueToApplication')
          }
        },
        buttonUrl: configuration.invitationButtonLink
      }
    }
  };
  var banenrProcessed = function banenrProcessed(state, email) {
    setShowBanner(state);
    setEmail(email);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !showBanner ? /*#__PURE__*/React.createElement("div", {
    className: "dac-login"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: get(configuration, 'registrationTitle.jss'),
    className: "dac-login__title"
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: get(configuration, 'registrationDescription.jss'),
    className: "dac-login__description"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap"
  }, /*#__PURE__*/React.createElement(DAcRegistrationForm, {
    redirectToBanner: banenrProcessed,
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey: apiKey,
      apiUrl: apiUrl
    },
    rtl: rtl
  })), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__intro"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    field: get(configuration, 'introText.jss'),
    className: "body-large "
  }), /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-secondary",
    field: {
      href: get(configuration, 'introButtonLink.jss.value.href')
    }
  }, get(configuration, 'introButtonTitle.jss.value')))) : /*#__PURE__*/React.createElement(DAcConfirmation, {
    rtl: rtl,
    fields: bannerFields,
    params: params
  }));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default DAcRegistration;
var commonStyles = "c5znr9e";
var ltrStyles = "lx0mrdn";
var rtlStyles = "r15jhcl8";